import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"
import _imports_0 from '../../assets/icons/upload-active.png'
import _imports_1 from '../../assets/icons/upload-inactive.png'


const _hoisted_1 = { class: "upload-area" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl underline" }, " Yüklenecek Dosyalar ", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "ac-upload-area"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Dosya Yükleme"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Eklemek için bırakın.", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "ac-upload-area text-2xl"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Dosya Yükleme"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Dosyaları sürükleyip bırakabilir veya buraya tıklayabilirsiniz.", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import accaFileDisplayer from "./accaFileDisplayer.vue"
import { ref, reactive, watch } from "vue"

// This is yet another component for a drag and drop area for uploading files.
// It differs from the fileUploadField.vue component in that it has no button, and from the fileUploadField.vue component in that it is more flexible.

import { RemoteFile } from "@/types"

import { useDropzone } from "vue3-dropzone"



export default /*#__PURE__*/_defineComponent({
  __name: 'fileUploadFlexible',
  props: {
    singleFile: {
        type: Boolean,
        default: false,
    },
    allow: {
        type: Array,
        default: () => [],
    },
},
  emits: ["filesChanged"],
  setup(__props, { emit: __emit }) {

const props = __props

const filePreview = ref([])

const uploads = reactive({
    files: [],
})

function onDrop(acceptFiles, rejectReasons) {
    console.log('acceptFiles ', acceptFiles);
    console.log('rejectreasons ', rejectReasons);

    if(rejectReasons.length > 0 && props.singleFile){
        alert("Lütfen bu alana sadece bir dosya yükleyin.")
        return
    }

    uploads.files = acceptFiles;
    console.log(uploads)
    previewFile(acceptFiles)

}

const options = {
    onDrop,
    accept: props.allow.length > 0 ? props.allow : '', // Use an empty string to allow all file types
    multiple: !props.singleFile
}

const { getRootProps, getInputProps, isDragActive, } = useDropzone(options);


function previewFile(files: File[]){
    
    // Loop over each file in the files argument and add it to the filePreview array
    
    files.forEach((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file)
        reader.onload = () => {
            const filePreviewObject: RemoteFile = {
                url: reader.result,
                name: file.name,
                type: file.type,
            }
            filePreview.value?.push(filePreviewObject)
        }
    })
}

const emits = __emit

// Emit the filesChanged event when the files change.

watch(uploads, () => {
    emits("filesChanged", uploads.files)
})

function removeLocalFile(index: number){
    // Remove the file from the filePreview array
    filePreview.value?.splice(index, 1)
    // Find the index of the file in the uploads.files array
    // Remove the file from the array
    uploads.files.splice(index, 1)

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (uploads.files.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_TransitionGroup, {
            class: "grid grid-cols-3 my-4 gap-4",
            type: "animation",
            "enter-active-class": "animate__animated animate__fadeIn",
            "leave-active-class": "animate__animated animate__fadeOut",
            tag: "section"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filePreview.value, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: file.name,
                  class: "file pl-2"
                }, [
                  _createVNode(accaFileDisplayer, {
                    class: "",
                    file: file
                  }, null, 8, ["file"]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (removeLocalFile(index)),
                    class: "text-xl text-red-400 hover:underline"
                  }, "Kaldır", 8, _hoisted_4)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _mergeProps(_unref(getRootProps)(), { class: "dropzone w-full border ac-form-dropzone bg-gray-100 text-center" }), [
      _createElementVNode("input", _normalizeProps(_guardReactiveProps(_unref(getInputProps)())), null, 16),
      (_unref(isDragActive))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
    ], 16)
  ]))
}
}

})